import React from 'react';

const MentionIcon = ({ color = '#9D9D9D', width = '16', height = '16', ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.99992 10.6669C9.47268 10.6669 10.6666 9.47293 10.6666 8.00017C10.6666 6.52741 9.47268 5.3335 7.99992 5.3335C6.52716 5.3335 5.33325 6.52741 5.33325 8.00017C5.33325 9.47293 6.52716 10.6669 7.99992 10.6669Z"
                stroke={color}
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.6666 5.3335V8.66684C10.6666 9.19727 10.8773 9.70598 11.2524 10.0811C11.6274 10.4562 12.1361 10.6669 12.6666 10.6669C13.197 10.6669 13.7057 10.4562 14.0808 10.0811C14.4559 9.70598 14.6666 9.19727 14.6666 8.66684V8.00017C14.6666 6.49837 14.1595 5.04057 13.2275 3.86295C12.2955 2.68533 10.9932 1.85689 9.53161 1.51184C8.06998 1.1668 6.53468 1.32537 5.17443 1.96187C3.81419 2.59837 2.7087 3.6755 2.03707 5.01875C1.36545 6.36199 1.16704 7.89266 1.47399 9.36276C1.78094 10.8329 2.57526 12.1563 3.72827 13.1185C4.88128 14.0808 6.32542 14.6256 7.82671 14.6646C9.32799 14.7036 10.7985 14.2346 11.9999 13.3335"
                stroke={color}
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default MentionIcon;
